"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indexTransformDependencies = void 0;

var _dependenciesIndexClassGenerated = require("./dependenciesIndexClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var indexTransformDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated.IndexDependencies,
  createIndexTransform: _factoriesAny.createIndexTransform
};
exports.indexTransformDependencies = indexTransformDependencies;